export const updateBoard = puzzle => ({
    type: 'UPDATE_BOARD',
    puzzle: puzzle,
});

const initialState = [
    {x: 0, y: 0}, {x: 3, y: 0}, {x: 6, y: 0}, {x: 9, y: 0},
    {x: 0, y: 5}, {x: 3, y: 5}, {x: 6, y: 5}, {x: 9, y: 5},
    {x: 0, y: 10}, {x: 3, y: 10}, {x: 6, y: 10}, {x: 9, y: 10}
];

const checkCurrentPage = puzzle => {
    let page = {};
    page.x = puzzle.x % 3 === 0 ? puzzle.x : findFirstX(puzzle.x);
    page.y = puzzle.y % 5 === 0 ? puzzle.y : findFirstY(puzzle.y);

    return page;
};

const findFirstX = x => {
    if (x % 3 !== 0) return findFirstX(x - 1);
    else return x;
};

const findFirstY = y => {
    if (y % 5 !== 0) return findFirstY(y - 1);
    else return y;
};

export default (state = initialState, action = {}) => {
    if (action.type === 'UPDATE_BOARD') {
        const currentPage = checkCurrentPage(action.puzzle);
        let newPages = [];
        let puzzlePosition = '';     // T = top; R = right; L = left; B = bottom

        if (currentPage.y === action.puzzle.y) {
            puzzlePosition = 'T';
        } else if ((currentPage.y + 4) === action.puzzle.y) {
            puzzlePosition = 'B';
        }

        if (currentPage.x === action.puzzle.x) {
            puzzlePosition += 'L';
        } else if ((currentPage.x + 2) === action.puzzle.x) {
            puzzlePosition += 'R';
        }
        switch (puzzlePosition) {
            case 'T':
                newPages = [{x: currentPage.x, y: currentPage.y - 5}];
                break;
            case 'B':
                newPages = [{x: currentPage.x, y: currentPage.y + 5}];
                break;
            case 'L':
                newPages = [{x: currentPage.x - 3, y: currentPage.y}];
                break;
            case 'R':
                newPages = [{x: currentPage.x + 3, y: currentPage.y}];
                break;
            case 'TL':
                newPages = [
                    {x: currentPage.x - 3, y: currentPage.y},
                    {x: currentPage.x - 3, y: currentPage.y - 5},
                    {x: currentPage.x, y: currentPage.y - 5}
                ];
                break;
            case 'TR':
                newPages = [
                    {x: currentPage.x, y: currentPage.y - 5},
                    {x: currentPage.x + 3, y: currentPage.y - 5},
                    {x: currentPage.x + 3, y: currentPage.y}
                ];
                break;
            case 'BL':
                newPages = [
                    {x: currentPage.x - 3, y: currentPage.y},
                    {x: currentPage.x - 3, y: currentPage.y + 5},
                    {x: currentPage.x, y: currentPage.y + 5}
                ];
                break;
            case 'BR':
                newPages = [
                    {x: currentPage.x + 3, y: currentPage.y},
                    {x: currentPage.x + 3, y: currentPage.y + 5},
                    {x: currentPage.x, y: currentPage.y + 5}
                ];
                break;
            default:
                return state;
        }

        newPages.forEach(page => {
            const exists = state.find(sPage => sPage.x === page.x && sPage.y === page.y);
            let toConcat = []
            if (!exists) {
                toConcat.push(page)
            }
        state = state.concat(toConcat);
        });
    }

    return state;
}




// WEBPACK FOOTER //
// ./src/state/sheets.js